import { PossibleInputInfo } from '@src/types/UtmGenerator'

export const transformInputInfo = (inputInfo: any, traffic: string): PossibleInputInfo => ({
  ...inputInfo,
  labelText: !inputInfo.labelText ? inputInfo.labelTextMap[traffic] : inputInfo.labelText
})
